<script>
export default {
  name: 'ReviewInfoAlternative',
  props: {
    description: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <v-card-text class="mx-2">
    <v-tooltip left>
      <template v-slot:activator="{ on: tooltip }">
        <p v-if="description" v-on="tooltip"> {{ description.text }}</p>
        <p v-else v-on="tooltip"> {{ $t('review.reviewCard.noDescription') }}</p>
      </template>
      <span>{{ $t('review.reviewCard.tooltip.description') }}</span>
    </v-tooltip>
  </v-card-text>
</template>



// WEBPACK FOOTER //
// src/components/review/ReviewInfoAlternative.vue